(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fuze-article-main"]) return;
  try {
    
  // Carrousels des blocs galerie : flèches précédent / suivant
  (function () {
    function initCarousels(root) {
      (root || document).querySelectorAll('[data-fz-carousel]').forEach(function (car) {
        if (car.dataset.fzInit) return;
        car.dataset.fzInit = '1';
        var track = car.querySelector('.fz-carousel__track');
        var prev = car.querySelector('.fz-carousel__nav--prev');
        var next = car.querySelector('.fz-carousel__nav--next');
        if (!track) return;
        function step() {
          var item = track.querySelector('.fz-carousel__item');
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
          return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        }
        prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    }
    initCarousels(document);
    // Prise en charge de l'aperçu dans l'éditeur de thème
    document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
